import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import "./PasswordInput.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';

class PasswordInput extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showPassword: false,
      isFocused: false
    };
  }

  toggleShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword
    })
  };

  setFocused = (isFocused) => {
    this.setState({
      isFocused: isFocused
    });
    this.props.onFocusChanged(isFocused);
  };

  onBlur = (e) => {
    this.setFocused(false);
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }
  };

  render() {
    let passwordInputContainerClass = classNames('hrb-new-password-container', {'hrb-new-password-container-focused': this.state.isFocused});

    return (
        <div className={passwordInputContainerClass}>
          <input
              tabIndex="4"
              className="form-control hrb-new-password-input"
              onChange={(e) => this.props.onPasswordChanged(e)}
              onFocus={(e) => this.setFocused(true)}
              onBlur={(e) => this.onBlur(e)}
              type={this.state.showPassword ? "text" : "password"}
          />
          <div className="hrb-show-password-toggle-container">
            <FontAwesomeIcon icon={this.state.showPassword ? faEye : faEyeSlash}
                         onClick={() => this.toggleShowPassword()}/>
          </div>
        </div>
    )
  };
}

PasswordInput.propTypes = {
  onPasswordChanged: PropTypes.func.isRequired,
  onFocusChanged: PropTypes.func,
  onBlur: PropTypes.func
};

export default PasswordInput;